import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'
import LazyImage from '../../elements/LazyImage'
import Button from '../../elements/Button'
import { getS3Url } from '../../helpers/getS3Url'

const StaffVertical = ({
  picture,
  cloudflare_picture,
  first_name,
  last_name,
  job,
  email,
  description,
  sizes,
  variant = []
}) => (
  <div className={withModifiers('staff', variant, styles)}>
    {picture && (
      <div className={styles.staff__image} key={picture}>
        <LazyImage
          alt={`Profile image-${picture}`}
          layout="fill"
          sizes={sizes}
          src={
            cloudflare_picture
              ? getS3Url(cloudflare_picture, '960')
              : getS3Url(picture)
          }
        />
      </div>
    )}

    {(first_name || last_name) && (
      <h3 className={styles.staff__name}>{`${first_name} ${last_name}`}</h3>
    )}

    {job && <div className={styles.staff__occupation}>{job}</div>}

    {description && <p className={styles.staff__description}>{description}</p>}

    <Button
      rel="nofollow"
      href={`mailto:${email}`}
      variant={['label', 'font-primary']}
    >
      Email {first_name}
    </Button>
  </div>
)

export default StaffVertical
